import { ref, Ref } from "vue"
import { BookingStatusEnum } from "@requests"

const iresaErrorStatus: Ref<
    BookingStatusEnum.CANCELLED |
    BookingStatusEnum.UNAVAILABLE |
    BookingStatusEnum.ERROR |
    BookingStatusEnum.OVERBOOKING |
    null
> = ref(null)

export default iresaErrorStatus